import { c as _c } from "react/compiler-runtime";
import type { SVGProps } from 'react';
export const IconDarkMode = t0 => {
  const $ = _c(10);
  let height;
  let props;
  let size;
  let width;
  if ($[0] !== t0) {
    ({
      size,
      width,
      height,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = height;
    $[2] = props;
    $[3] = size;
    $[4] = width;
  } else {
    height = $[1];
    props = $[2];
    size = $[3];
    width = $[4];
  }
  const t1 = size ?? width ?? 24;
  const t2 = size ?? height ?? 24;
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <path fill="currentColor" fillRule="evenodd" d="M38.718 62.077c6.415-.42 12.513-2.859 17.388-6.956.699-.587.927-.862 1.046-1.26.292-.98-.137-2.005-1.02-2.437-.513-.25-.9-.266-1.766-.068-1.387.318-2.309.428-3.888.466-2.07.05-3.475-.099-5.36-.565-5.596-1.384-10.355-5.206-12.948-10.398-1.402-2.806-2.07-5.667-2.07-8.859 0-3.73.939-7.105 2.874-10.328 1.278-2.128 3.249-4.253 5.36-5.779a19.7 19.7 0 0 1 8.32-3.47c1.185-.2 1.977-.263 3.314-.262 1.627 0 2.922.147 4.526.512.958.218 1.544.097 2.126-.439.528-.487.738-1.21.567-1.954-.102-.448-.33-.756-.968-1.306-3.049-2.634-7.142-4.811-11.21-5.962-2.744-.777-5.205-1.114-8.115-1.113-2.526 0-4.35.192-6.642.698C18.359 5.222 9.162 14.87 7.108 26.88c-.33 1.929-.387 2.687-.388 5.152 0 2.458.048 3.094.387 5.088 1.24 7.287 5.22 13.965 11.067 18.563 4.064 3.198 9.024 5.345 14.112 6.11 1.869.281 4.616.402 6.432.284m-.256-4.004c1.713-.133 3.358-.4 4.868-.791 1.345-.349 3.337-1.04 4.045-1.402l.226-.116-.442-.044c-2.536-.25-5.876-1.279-8.281-2.551-7.079-3.746-11.704-10.497-12.682-18.513-.116-.948-.116-4.364 0-5.312.637-5.226 2.835-9.98 6.316-13.663 3.997-4.23 9.122-6.781 14.942-7.44.112-.012-.107-.128-.726-.385-9.86-4.086-21.357-1.665-28.754 6.053-4.071 4.25-6.517 9.55-7.165 15.531-.211 1.948-.116 4.785.23 6.835 1.748 10.35 9.419 18.613 19.583 21.094 2.011.49 3.575.68 5.824.708.933.012 1.84.01 2.016-.004" clipRule="evenodd" />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== props || $[7] !== t1 || $[8] !== t2) {
    t4 = <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 64 64" width={t1} height={t2} {...props}>{t3}</svg>;
    $[6] = props;
    $[7] = t1;
    $[8] = t2;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
IconDarkMode.displayName = 'IconDarkMode';